var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 83 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 30.75C25.0416 30.75 30.75 25.0416 30.75 18C30.75 10.9584 25.0416 5.25 18 5.25C10.9584 5.25 5.25 10.9584 5.25 18C5.25 25.0416 10.9584 30.75 18 30.75ZM18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 207 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9987 10.125C18.62 10.125 19.1237 10.6287 19.1237 11.25V11.728C20.3201 11.9629 21.1273 12.5826 21.6005 13.4106C22.1254 14.3293 22.1242 15.332 22.1237 15.7178C22.1237 15.7291 22.1237 15.7398 22.1237 15.7499C22.1238 16.3713 21.6201 16.875 20.9988 16.875C20.3775 16.875 19.8738 16.3714 19.8737 15.7501C19.8737 15.3596 19.8567 14.894 19.6469 14.5269C19.5056 14.2796 19.1671 13.875 17.9987 13.875C16.7602 13.875 16.3644 14.2709 16.2232 14.4881C16.0362 14.7758 16.0159 15.1804 16.0901 15.4771C16.2162 15.9814 16.5883 16.344 18.3545 16.9327C19.5126 17.3188 20.4749 17.7602 21.1379 18.4233C21.8687 19.154 22.1237 20.0325 22.1237 21C22.1237 22.1769 21.2004 23.8194 19.1237 24.2616V24.75C19.1237 25.3713 18.62 25.875 17.9987 25.875C17.3774 25.875 16.8737 25.3713 16.8737 24.75V24.259C16.0067 24.0687 15.304 23.6487 14.7907 23.0327C14.1008 22.2048 13.8737 21.1671 13.8737 20.25C13.8737 19.6287 14.3774 19.125 14.9987 19.125C15.62 19.125 16.1237 19.6287 16.1237 20.25C16.1237 20.8329 16.2716 21.2952 16.5192 21.5923C16.7367 21.8533 17.1442 22.125 17.9987 22.125C19.6274 22.125 19.8737 21.1287 19.8737 21C19.8737 20.4675 19.7537 20.221 19.5469 20.0142C19.2725 19.7398 18.7348 19.4312 17.643 19.0673C15.994 18.5176 14.3642 17.8504 13.9073 16.0229C13.7315 15.3196 13.7112 14.2242 14.3367 13.2619C14.8545 12.4653 15.704 11.9238 16.8737 11.7177V11.25C16.8737 10.6287 17.3774 10.125 17.9987 10.125Z",
    fill: "#221AFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.b17a756329cc38f9e6caf1e905fc5015.svg";
export { ForwardRef as ReactComponent };